import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { Divider, TextField } from "@mui/material";
import { deleteVendor, editVendor } from "./api";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 700,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

export default function EditModal({
  row,
  openModal,
  handleCloseModal,
  setVendorsArray,
}) {
  const [vendorData, setVendorData] = React.useState(row);

  const onChange = (e) => {
    setVendorData({ ...vendorData, [e.target.name]: e.target.value });
  };

  const onEditVendor = async () => {
    console.log(vendorData);
    const data = await editVendor(row.id, vendorData);
    console.log(data);
    if (data?.[0]) {
      setVendorsArray(data);
    }
    handleCloseModal();
  };

  return (
    <div>
      <Modal open={openModal} onClose={handleCloseModal}>
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Edit Vendor: ({row.name})
          </Typography>
          <Divider sx={{ my: 1.5 }} />

          <Box sx={{ py: 2 }}>
            <TextField
              id="name"
              name="name"
              label="Name"
              fullWidth
              autoComplete="off"
              onChange={onChange}
              value={vendorData?.name}
              variant="standard"
              sx={{ m: 1, mt: 0 }}
            />
            <TextField
              id="email"
              name="email"
              label="Email"
              fullWidth
              autoComplete="off"
              onChange={onChange}
              value={vendorData?.email}
              variant="standard"
              sx={{ m: 1, mt: 0 }}
            />
          </Box>
          <Typography>
            - Editing vendors data will update their information everywhere on
            the website, but their attached purchase orders will remain
            unchanged.
          </Typography>
          <Box sx={{ textAlign: "right" }}>
            <Button
              color="success"
              variant="outlined"
              onClick={handleCloseModal}
            >
              close
            </Button>

            <Button
              color="success"
              variant="contained"
              sx={{ mx: 1 }}
              onClick={onEditVendor}
            >
              Edit
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  );
}
